import { MonitorCog, Network, UserCog } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const settingsTiles = [
  { icon: MonitorCog, label: "System", value: "Identity, display, storage" },
  { icon: Network, label: "Network", value: "Adapters, DNS, IP settings" },
  { icon: UserCog, label: "Accounts", value: "Sign-in and local access" }
];

export function SettingsApp({ activeMachine, app, onOpenApp, onRunCommand, profile }: SimulatorAppSurfaceProps) {
  return (
    <div className="fd-sim-app fd-sim-settings">
      <aside className="fd-settings-sidebar">
        <strong>{profile.productLabel}</strong>
        <span>{activeMachine}</span>
        <button className="is-active" type="button">System</button>
        <button type="button" onClick={() => onOpenApp("ncpa", "start")}>Network</button>
        <button type="button" onClick={() => onOpenApp("lusrmgr", "start")}>Accounts</button>
      </aside>
      <section className="fd-settings-content">
        <header>
          <p>{activeMachine}</p>
          <h2>{app.title}</h2>
        </header>
        <div className="fd-settings-tiles">
          {settingsTiles.map((tile) => {
            const Icon = tile.icon;
            return (
              <button
                key={tile.label}
                type="button"
                onClick={() => {
                  void onRunCommand({
                    appId: app.id,
                    commandType: "RECORD_APP_CHECK",
                    capability: app.launchCapability ?? "simulator.check",
                    label: tile.label,
                    payload: { appId: app.id, page: tile.label, title: app.title, machineId: activeMachine }
                  });
                }}
              >
                <Icon size={20} />
                <span>
                  <strong>{tile.label}</strong>
                  <small>{tile.value}</small>
                </span>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
